import { dreamService } from "motw_core/Services/DreamService";
import { hashTagsService } from "motw_core/Services/HashTagsService";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export function GetActiveDreamHashTags() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (!dreams) {
        return [];
    }

    const searchText = dreams.state.searchText;

    if (!searchText) {
        return [];
    }

    const activeHashTags = searchText
        .split(` `)
        .filter(hashTagsService.HashTagsFilter);

    return activeHashTags;
}
